export default __webpack_public_path__ + "static/media/Group7558-new.d4d350bd.png";